import { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import { FaEye } from 'react-icons/fa';

const CarouselImage = ({ images }) => {
    const [open, setOpen] = useState(false);


    const slides = images.map((img) => ({
        src: `${process.env.REACT_APP_API_BASE_URL}/` + img.filepath,
        alt: img.filename || 'Image',
        width: 1200,      // Required for Zoom
        height: 800       // Required for Zoom
    }));

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                className="btn btn-sm"
            >
                <FaEye title="View Images" />
            </button>

            <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={slides}
                plugins={[Thumbnails, Zoom]}
            />
        </>
    );
};

export default CarouselImage;
